import { mapState } from 'vuex';

export default {
  name: 'MaterialLookup',
  props: {
    disabled: Boolean,
    datePeriodId: String
  },
  data () {
    return {
      displayItems: false,
      items: null,
      parentTitles: null,
      searchTxt: ''
    }
  },
  computed: {
    ...mapState(['config']),
    filteredItems () {
      if (this.displayItems) {
        const tmpStr = this.searchTxt.toLowerCase();
        return this.items.filter(el => el.code.toLowerCase().indexOf(tmpStr) === 0);
      }
      return null;
    }
  },
  methods: {
    getParentName (item) {
      let resStr = '';
      const self = this;
      if (item.parents) {
        item.parents.forEach(function (elId) {
          if (self.parentTitles[elId]) {
            resStr = self.BasicHelper.getTranslation(self.parentTitles[elId]) + ' ' + resStr;
          }
        });
      }
      return resStr;
    },
    getItemName (item) {
      return item.code + ': ' + this.getParentName(item) + this.BasicHelper.getTranslation(item.title);
    },
    clearSearch () {
      this.searchTxt = '';
      this.displayItems = false;
    },
    changeSearchTxt () {
      this.displayItems = true;
    },
    getItems () {
      const self = this;
      let path = 'material/lookup';
      if (this.datePeriodId) {
        path = path + '/' + this.datePeriodId
      }
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          const items = {};
          response.data.items.forEach(el => {
            if (!items[el.code]) {
              items[el.code] = el;
              items[el.code].materialIds = [];
            }
            items[el.code].materialIds.push(el.material_id);
          });
          self.parentTitles = response.data.titles;
          self.items = Object.values(items);
        }
      });
    },
    itemSelected (item) {
      this.$emit('selected', item.materialIds);
      this.displayItems = false;
    }
  },
  mounted () {
    this.getItems();
  }
}
